var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusCheckGremlin(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.15 7.197l-5.065 3.362c-.223-.296-.423-.535-.595-.794-1.952-2.957-4.682-4.222-8.06-3.537-3.437.697-5.634 2.977-6.502 6.467-.965 3.885.584 7.927 3.726 10.004 2.436 1.611 5.041 1.75 7.692.729 1.87-.72 3.043-2.176 3.73-4.332h-6.55V13.82h13.04c.268 1.978.13 3.899-.333 5.79-1.668 6.812-7.535 10.984-14.478 10.322C7.166 29.302 1.894 24.366.663 17.672-1.043 8.392 6.178-.283 15.354.007c4.59.145 8.266 2.084 11.008 5.878.275.381.488.81.787 1.312z",
    fill: "#63C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCheckGremlin);
export default __webpack_public_path__ + "static/media/status-check-gremlin.e15d7e990a31372c639225b1ce83053e.svg";
export { ForwardRef as ReactComponent };